import React from "react";
import "croppie/croppie.css";
import { connect } from "react-redux";
import Rotate90DegreesCcwTwoToneIcon from "@material-ui/icons/Rotate90DegreesCcwTwoTone";
import { IconButton, LinearProgress } from "@material-ui/core";
import SaveTwoToneIcon from "@material-ui/icons/SaveTwoTone";
import CropTwoToneIcon from "@material-ui/icons/CropTwoTone";
import "./ProfileImageUploader.css";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { securityHelper } from "../../../../helpers/securityHelper";
import ReplayIcon from "@material-ui/icons/Replay";

const Croppie = require("croppie");

class ProfileImageUploader extends React.Component {
  state = {
    source: "",
    isCropping: false,
    imageLoaded: false,
    defaultImage: "https://www.xovi.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png",
  };

  componentDidMount() {
    const { source, dispatch, cms } = this.props;

    this.setState({ source: source || this.state.defaultImage });
  }

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  onImageUpload = async (e) => {
    const { cms, dispatch, element } = this.props;

    const file = e.target.files[0];

    const result = await this.toBase64(file).catch((e) => Error(e));
    if (result instanceof Error) {
      console.error("Error: ", result.message);
      this.setState({ errorMessage: result.message });
      return;
    }

    this.setState({ isCropping: true, source: result });
  };
  setImageOnOrder = (source) => {
    this.setState({ source });
    this.props.setImage(source);
    //props.load
  };
  onCropped = (source) => {
    const { cms, dispatch, element } = this.props;
    this.setState({ isCropping: false });
    this.setImageOnOrder(source);
  };
  setImageClassName = (type) => {
    switch (type) {
      case "SQUARE":
        return "square--landscape";
      case "CIRCLE":
        return "circular--landscape";
      default:
        return "";
    }
  };
  handleImageLoaded = () => this.setState({ imageLoaded: true });

  render() {
    const { source, isCropping } = this.state;
    const { cms, template, onRestore = null } = this.props;

    return (
      <div className="w-100 " style={{ padding: 15 }}>
        {!this.state.isCropping && (
          <div className={`image-container responsive-col-image-alignment ${this.setImageClassName("CIRCLE")}`} style={{ width: "150px", height: "150px" }}>
            <img ref={(r) => (this.imgRef = r)} onLoad={this.handleImageLoaded} src={source} className={`image-content ${this.state.imageLoaded ? "unblur" : "blur"}`} alt="image" />
          </div>
        )}

        <div style={{ margin: "10px auto", marginBottom: 0 /* , marginTop: isCropping ? '40px' : 0 */ }}>
          {isCropping ? (
            <ProfileImageCropper
              source={this.state.source}
              shape={"circle"}
              size={{ height: 800, width: 800 }}
              viewport={{ height: 150, width: 150 }}
              parentId={securityHelper.createGuid()}
              onCropped={this.onCropped}
              backgroundColor={"#fff"}
            />
          ) : null}
          {!isCropping ? (
            <label htmlFor="file-upload-pfi" className="archive-toolbar-btn">
              <i className="fa fa-upload"></i>
              {"  "}
              <SystemLabel name="UploadImage" lang="swe" />
            </label>
          ) : null}
          {!isCropping ? (
            <button disabled={this.state.source == this.state.defaultImage} className="archive-toolbar-btn" onClick={() => this.setState({ isCropping: true })}>
              <CropTwoToneIcon style={{ fontSize: 20 }} />
              {"  "}
              <SystemLabel name="Crop" lang="swe" />
            </button>
          ) : null}
          {!isCropping && onRestore ? (
            <button disabled={this.state.source == this.state.defaultImage} className="archive-toolbar-btn" onClick={() => this.props.onRestore()}>
              <ReplayIcon style={{ fontSize: 20 }} />
              {"  "}
              <SystemLabel name="Restore" /*  lang="swe" */ />
            </button>
          ) : null}
        </div>

        <input id="file-upload-pfi" className="file-upload" type="file" accept="png,jpg,svg" /* multiple */ onChange={(e) => this.onImageUpload(e)} />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template.template,
    cms: state.cms,
    attendee: state.attendee,
  };
}
export default connect(mapStateToProps)(ProfileImageUploader);

class ProfileImageCropper extends React.Component {
  state = {
    zoom: 0,
    isLoading: false,
  };
  componentDidMount() {
    this.init();
  }
  init = (reRender = false) => {
    const { size, shape, parentId, viewport, backgroundColor } = this.props;

    if (this.cropper) {
      this.cropper.destroy();
    }
    if (size !== null || reRender) {
      this.cropper = new Croppie(document.getElementById("croppie-img-" + parentId), {
        viewport: { ...viewport, type: shape.toLowerCase() },
        boundary: viewport,
        showZoomer: true,
        type: "base64",
        enableOrientation: true,
      });

      this.handleZoomOut(0);
      let listNodes = document.getElementsByClassName("cr-vp-square");

      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${backgroundColor}`;
      }
      listNodes = document.getElementsByClassName("cr-vp-circle");
      if (listNodes[0]) {
        listNodes[0].style.boxShadow = `0px 0px 2000px 2000px ${backgroundColor}`;
      }
    }
  };
  componentDidUpdate(prevProps) {
    const { hideOverlay, size, source, isCropping } = this.props;

    if (hideOverlay !== undefined && prevProps.hideOverlay !== hideOverlay && hideOverlay == false) {
      this.init(true);
    }
    /*  if ((prevProps.size !== size && size !== undefined && size !== null && !this.size) || prevProps.source !== source) {
             this.init();
         } */
    if (source !== undefined && prevProps.source !== source) {
      this.init();
    }
    if (isCropping !== isCropping) {
      this.init();
    }
  }

  handleZoomOut = (scale, controlled = false) => {
    if (this.cropper !== undefined) {
      const cZoom = this.cropper.get().zoom;
      if (!controlled && scale === 0) {
        this.setState({ zoom: scale }, () => {
          this.cropper.setZoom(scale);
        });
        return;
      }
      if (controlled === true && scale !== undefined) {
        this.setState({ zoom: scale }, () => {
          this.cropper.setZoom(scale);
        });
        return;
      }
      if (cZoom !== this.state.zoom) {
        if (cZoom === 50) {
          this.cropper.setZoom(0);
          this.setState({ zoom: 0 });
          return;
        }
        this.setState({ zoom: cZoom });
      }
    }
  };
  handlResult = () => {
    const { size } = this.props;
    this.setState({ isLoading: true });
    this.cropper.result({ type: "base64", size }).then((res) => this.handleSave(res));
  };
  handleSave = (res) => {
    const { onCropped } = this.props;
    onCropped(res);
  };
  rotate = () => {
    this.cropper.rotate(90);
  };
  render() {
    const { shape, size, parentId, viewport, hideOverlay, source } = this.props;
    return (
      <React.Fragment>
        <div>
          {this.state.isLoading ? <LinearProgress /> : null}
          <div id="inline-croppie-overlay" onWheel={this.handleZoomOut} className="inline-croppie-overlay" style={{ width: "100%", paddingBottom: 0, position: "relative" }}>
            <img id={`croppie-img-${parentId}`} src={source.includes("jirangopub") ? `${source}?rnd=${Date.now()}` : source} />
            <div style={{ width: "50%", left: `25%`, bottom: "12px" }} className={`croppie-controllers pi-crop expo-pf  `}>
              <div style={{ display: "inline-flex", margin: "0px" }}>
                <IconButton onClick={this.rotate}>
                  <Rotate90DegreesCcwTwoToneIcon />
                </IconButton>
                <IconButton onClick={this.handlResult}>
                  <SaveTwoToneIcon />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
